// IMPORT REACT
import React from 'react';

// IMPORT IMAGES
import { ReactComponent as WeemarkableLogo } from '../../images/weemarkable-logo.svg';
import { ReactComponent as YMCAIconLogo } from '../../images/ymca-icon-logo.svg';
import { ReactComponent as YMCATextLogo } from '../../images/ymca-text-logo.svg';

// IMPORT STYLES
import { SC_Logo, SC_IconRatio, SC_CanvasRatio } from './styles';

const identifyComponent = (icon) => {
	const components = {
        'weemarkable': WeemarkableLogo,
	    'ymca-icon': YMCAIconLogo,
	    'ymca-text': YMCATextLogo,
	  
	}
	return components[icon] ? components[icon] : components['weemarkable'];
} 

// const YALogo = (props) => {
//     return (
//     	<SC_Logo {...props} >
//             {
//                 props.brand == 'ymca-icon' ? <YMCAIconLogo/> :
//                 props.brand == 'ymca-text' ? <YMCATextLogo/> :
//                 <WeemarkableLogo/>
//             }
//         </SC_Logo> 
//     )
    
// }
// export default YALogo;

class YALogo extends React.Component {

	state = {
		iconWidth: null,
		iconHeight: null
	};

	refCallback = element => {
		if (element) {
			const iconViewBox = element.getAttribute('viewBox').split(' ');
			this.setState({ 
				iconWidth: iconViewBox[2],
				iconHeight: iconViewBox[3] 
			});
		}
	};

	render(){
		let Template = identifyComponent(this.props.brand);
		let iconWidth = this.state.iconWidth;
		let iconHeight = this.state.iconHeight;
    return (
    	<SC_Logo {...this.props}>
				<SC_IconRatio>
					<SC_CanvasRatio width={iconWidth} height={iconHeight} />
    			    <Template aria-labelledby={'logo-'+this.props.brand} ref={this.refCallback} />
				</SC_IconRatio>
    	</SC_Logo>
  	)
	}
}
export default YALogo;